import React,{ useState, useEffect, useRef } from "react"
import {
  MdUpload,
  MdDelete,
  MdEdit,
  MdSave,
  MdFormatAlignLeft,
  MdFormatAlignCenter,
  MdFormatAlignRight,
  MdQrCode,
} from "react-icons/md"
import { IoClose } from "react-icons/io5"
import { FaCertificate } from "react-icons/fa"
import { Modal, Button } from "react-bootstrap"
import { uploadFilesAWS, createCertificate, UpdateCertificate, GetTicketsByID } from "../../../api/Webservices"
import { useLocation, useHistory } from "react-router-dom"
import { showToast, ToastMessage } from "../../Shared/ToastMessage"
function Certificate() {
  const EventID = localStorage.getItem("eventId") || ""
  const history = useHistory()
  const location = useLocation()
  const certificateRef = useRef(null)
  const bgImageInputRef = useRef(null)
  const imageInputRef = useRef(null)
  const [pageSizeConfirmed, setPageSizeConfirmed] = useState(false)
  const [backgroundCompleted, setBackgroundCompleted] = useState(false)
  const [isLocked, setIsLocked] = useState(false)
  const [isGenerating, setIsGenerating] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [certificateId, setCertificateId] = useState(null)
  const [bgFile, setBgFile] = useState(null)
  const [bgPreview, setBgPreview] = useState(null)
  const [backgroundUploadStatus, setBackgroundUploadStatus] = useState("idle")
  const [useDefaultBackground, setUseDefaultBackground] = useState(false)
  const [imageFiles, setImageFiles] = useState([])
  const [qrText, setQrText] = useState("<https://example.com>")
  const [qrImage, setQrImage] = useState(null)
  const [qrUrl, setQrUrl] = useState(null)
  const [qrPosition, setQrPosition] = useState({ x: 100, y: 100 })
  const [qrSize, setQrSize] = useState({ width: 120, height: 120 })
  const [isDragging, setIsDragging] = useState(false)
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 })
  const [draggingTextId, setDraggingTextId] = useState(null)
  const [draggingImageId, setDraggingImageId] = useState(null)
  const [resizingImageId, setResizingImageId] = useState(null)
  const [resizingQR, setResizingQR] = useState(false)
  const [resizingTextId, setResizingTextId] = useState(null)
  const [certificateTitle, setCertificateTitle] = useState("New Certificate Template")
  const [showHtmlModal, setShowHtmlModal] = useState(false)
  const [generatedHtml, setGeneratedHtml] = useState("")
  const [alertModal, setAlertModal] = useState({
    show: false,
    message: "",
    variant: "info",
  })
  const [confirmModal, setConfirmModal] = useState({
    show: false,
    message: "",
    onConfirm: null,
  })
  const [pageSettings, setPageSettings] = useState({ width: 384, height: 576 })
const [selectedPageSize, setSelectedPageSize] = useState("4×6 inch")
const [certificateSize, setCertificateSize] = useState("4x6")  
const [activeTab, setActiveTab] = useState("fields")
const pageWidth = pageSettings.width
const pageHeight = pageSettings.height
const pageSizeOptions = [
  { name: "4×6 inch", width: 384, height: 576, size: "4x6", inchW: 4, inchH: 6 },
  { name: "A4", width: 794, height: 1123, size: "a4", inchW: 8.27, inchH: 11.69 },
  { name: "A4 Landscape", width: 1123, height: 794, size: "a4_landscape", inchW: 11.69, inchH: 8.27 },
  { name: "Letter", width: 816, height: 1056, size: "letter", inchW: 8.5, inchH: 11 },
  { name: "Letter Landscape", width: 1056, height: 816, size: "letter_landscape", inchW: 11, inchH: 8.5 },
]


const matchedSize = pageSizeOptions.find(opt => opt.size === certificateSize)
const CERTIFICATE_SIZE_INCHES = {
  w: matchedSize?.inchW || 4,
  h: matchedSize?.inchH || 6
}
  const fontFamilies = [
    "Arial",
    "Helvetica",
    "Times New Roman",
    "Georgia",
    "Courier New",
    "Verdana",
    "Trebuchet MS",
    "Impact",
    "Comic Sans MS",
    "Palatino",
    "Garamond",
  ]
  const fontWeights = [
    { label: "Thin", value: "100" },
    { label: "Light", value: "300" },
    { label: "Regular", value: "400" },
    { label: "Medium", value: "500" },
    { label: "Semi Bold", value: "600" },
    { label: "Bold", value: "700" },
    { label: "Extra Bold", value: "800" },
    { label: "Black", value: "900" },
  ]
  const showPreviewElements = backgroundCompleted
  const isStep2Enabled = backgroundCompleted && !isLocked
  const DEFAULT_BACKGROUND_URL = "https://amasi.org/wp-content/uploads/2025/12/backgroudwhite.png"
  const [inputFields, setInputFields] = useState([
    {
      id: "attendee_name",
      label: "Attendee Name",
      placeholder: "ATTENDEE_NAME",
      fieldKey: "ATTENDEE_NAME",
      visible: false,
      x: 150,
      y: 150,
      width: 200,
      height: 50,
      fontSize: 16,
      fontFamily: "Arial",
      fontWeight: "700",
      color: "#000000",
      textAlign: "center",
    },
    {
      id: "email",
      label: "Email",
      placeholder: "EMAIL",
      fieldKey: "EMAIL",
      visible: false,
      x: 150,
      y: 200,
      width: 200,
      height: 30,
      fontSize: 16,
      fontFamily: "Arial",
      fontWeight: "400",
      color: "#333333",
      textAlign: "center",
    },
    {
      id: "organization",
      label: "Organization",
      placeholder: "ORGANIZATION",
      fieldKey: "ORGANIZATION",
      visible: false,
      x: 150,
      y: 250,
      width: 200,
      height: 30,
      fontSize: 16,
      fontFamily: "Arial",
      fontWeight: "400",
      color: "#333333",
      textAlign: "center",
    },
    {
      id: "event_name",
      label: "Event Name",
      placeholder: "EVENT_NAME",
      fieldKey: "EVENT_NAME",
      visible: false,
      x: 150,
      y: 300,
      width: 200,
      height: 40,
      fontSize: 16,
      fontFamily: "Arial",
      fontWeight: "600",
      color: "#000000",
      textAlign: "center",
    },
    {
      id: "venue",
      label: "Venue",
      placeholder: "VENUE",
      fieldKey: "VENUE",
      visible: false,
      x: 150,
      y: 350,
      width: 200,
      height: 30,
      fontSize: 16,
      fontFamily: "Arial",
      fontWeight: "400",
      color: "#666666",
      textAlign: "center",
    },
    {
      id: "event_date",
      label: "Event Date",
      placeholder: "EVENT_DATE",
      fieldKey: "EVENT_DATE",
      visible: false,
      x: 150,
      y: 400,
      width: 200,
      height: 30,
      fontSize: 16,
      fontFamily: "Arial",
      fontWeight: "400",
      color: "#666666",
      textAlign: "center",
    },
    {
      id: "ticket_type",
      label: "Ticket Type",
      placeholder: "TICKET_TYPE",
      fieldKey: "TICKET_TYPE",
      visible: false,
      x: 150,
      y: 450,
      width: 200,
      height: 30,
      fontSize: 16,
      fontFamily: "Arial",
      fontWeight: "500",
      color: "#333333",
      textAlign: "center",
    },
    {
      id: "registration_number",
      label: "Registration Number",
      placeholder: "REGISTRATION_NUMBER",
      fieldKey: "REGISTRATION_NUMBER",
      visible: false,
      x: 150,
      y: 500,
      width: 200,
      height: 25,
      fontSize: 16,
      fontFamily: "Arial",
      fontWeight: "400",
      color: "#666666",
      textAlign: "center",
    },
  ])
  const [qrVisible, setQrVisible] = useState(false)
  const [selectedFieldId, setSelectedFieldId] = useState(null)
  const selectedField = inputFields.find((f) => f.id === selectedFieldId)
  const [tickets, setTickets] = useState([])
  const [selectedTickets, setSelectedTickets] = useState([0])
  const [isTicketDropdownOpen, setIsTicketDropdownOpen] = useState(false)
  const ticketDropdownRef = useRef(null)
  const showAlert = (message, variant = "info") => {
    setAlertModal({ show: true, message, variant })
  }
  const showConfirm = (message, onConfirm) => {
    setConfirmModal({ show: true, message, onConfirm })
  }
  const addCustomField = () => {
    if (isLocked) return
    const customCount = inputFields.filter((f) => !f.fieldKey).length + 1
    const newId = `custom_${Date.now()}`
    const newField = {
      id: newId,
      label: `Custom Text ${customCount}`,
      text: "Enter custom text",
      visible: true,
      x: 150,
      y: 150,
      width: 200,
      height: 30,
      fontSize: 16,
      fontFamily: "Arial",
      fontWeight: "400",
      color: "#000000",
      textAlign: "center",
    }
    setInputFields((prev) => [...prev, newField])
    setSelectedFieldId(newId)
  }
  const deleteCustomField = (id) => {
    if (isLocked) return
    setInputFields((prev) => prev.filter((f) => f.id !== id))
    if (selectedFieldId === id) setSelectedFieldId(null)
  }
  const toggleFieldVisibility = (id) => {
    if (isLocked) return
    setInputFields((prev) => prev.map((field) => (field.id === id ? { ...field, visible: !field.visible } : field)))
    const field = inputFields.find((f) => f.id === id)
    if (!field.visible) setSelectedFieldId(id)
  }
  const updateField = (id, updates) => {
    if (isLocked) return
    setInputFields((prev) => prev.map((field) => (field.id === id ? { ...field, ...updates } : field)))
  }
  const deleteImage = (id) => {
    if (isLocked) return
    setImageFiles((prev) => prev.filter((img) => img.id !== id))
  }
  const handleClearAllImages = () => {
    if (isLocked) return
    showConfirm("Are you sure you want to remove all uploaded images?", () => {
      setImageFiles([])
      if (imageInputRef.current) {
        imageInputRef.current.value = ""
      }
    })
  }
  const handleRemoveBackground = () => {
    showConfirm("Are you sure you want to remove the background image?", () => {
      setBgFile(null)
      setBgPreview(null)
      setBackgroundUploadStatus("idle")
      setUseDefaultBackground(false)
      if (bgImageInputRef.current) {
        bgImageInputRef.current.value = ""
      }
    })
  }
  const handleChangeBackground = () => {
    showConfirm("This will reset and allow you to upload new background/images. Continue?", () => {
      setBgPreview(null)
      setBackgroundCompleted(false)
      setImageFiles([])
      setBackgroundUploadStatus("idle")
      setBgFile(null)
      setUseDefaultBackground(false)
    })
  }
  const handleDefaultBackgroundToggle = () => {
    if (isLocked) return
    const newValue = !useDefaultBackground
    setUseDefaultBackground(newValue)
    if (newValue) {
      // Apply default background
      setBgPreview(DEFAULT_BACKGROUND_URL)
      setBackgroundUploadStatus("success")
      setBgFile(null)
      if (bgImageInputRef.current) {
        bgImageInputRef.current.value = ""
      }
    } else {
      // Clear default background
      setBgPreview(null)
      setBackgroundUploadStatus("idle")
    }
  }
  const mergeBackground = async () => {
    setIsGenerating(true)
    try {
      const hide = () => {
        document.querySelectorAll(".text-field, .qr, .resize-handle, .delete-btn").forEach((el) => {
          el.style.display = "none"
        })
      }
      const show = () => {
        document.querySelectorAll(".text-field, .qr, .resize-handle, .delete-btn").forEach((el) => {
          el.style.display = ""
        })
      }
      hide()
      await new Promise((r) => setTimeout(r, 100))
      const html2canvas = (await import("html2canvas")).default
      const canvas = await html2canvas(certificateRef.current, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: null,
      })
      show()
      const blob = await new Promise((r) => canvas.toBlob(r, "image/png"))
      const mergedFile = new File([blob], `merged-bg-${Date.now()}.png`, {
        type: "image/png",
      })
      const response = await uploadFilesAWS([mergedFile])
      const uploadedUrls = response?.data?.uploadedUrls || response?.uploadedUrls || {}
      const mergedBgUrl = Object.values(uploadedUrls).flat().pop()
      if (!mergedBgUrl) throw new Error("Failed to get merged background URL")
      setBgPreview(mergedBgUrl)
      setImageFiles([])
      setBackgroundCompleted(true)
      setBgFile(null)
      setActiveTab("fields")
      return mergedBgUrl
    } catch (err) {
      console.error(err)
      showAlert("Failed to merge: " + (err.message || "Unknown error"), "danger")
      throw err
    } finally {
      setIsGenerating(false)
    }
  }
  useEffect(() => {
    if (qrText.trim() && qrVisible) {
      import("qrcode").then((QRCode) => {
        QRCode.default.toDataURL(qrText, { width: 300, margin: 1 }).then(setQrImage).catch(console.error)
      })
    } else {
      setQrImage(null)
    }
  }, [qrText, qrVisible])
  const handleTextMouseDown = (e, id) => {
    if (isLocked) return
    e.stopPropagation()
    setSelectedFieldId(id)
    const rect = e.currentTarget.getBoundingClientRect()
    setDragOffset({ x: e.clientX - rect.left, y: e.clientY - rect.top })
    setDraggingTextId(id)
  }
  const handleTextResizeDown = (e, id) => {
    if (isLocked) return
    e.stopPropagation()
    setResizingTextId(id)
    setDragOffset({ x: e.clientX, y: e.clientY })
  }
  const handleImageMouseDown = (e, id) => {
    if (isLocked) return
    e.stopPropagation()
    const rect = e.currentTarget.getBoundingClientRect()
    setDragOffset({ x: e.clientX - rect.left, y: e.clientY - rect.top })
    setDraggingImageId(id)
  }
  const handleImageResizeDown = (e, id) => {
    if (isLocked) return
    e.stopPropagation()
    setResizingImageId(id)
    setDragOffset({ x: e.clientX, y: e.clientY })
  }
  const handleQRMouseDown = (e) => {
    if (isLocked) return
    const rect = e.currentTarget.getBoundingClientRect()
    setDragOffset({ x: e.clientX - rect.left, y: e.clientY - rect.top })
    setIsDragging(true)
  }
  const handleQRResizeDown = (e) => {
    if (isLocked) return
    e.stopPropagation()
    setResizingQR(true)
    setDragOffset({ x: e.clientX, y: e.clientY })
  }
  const handleMouseMove = (e) => {
    if (!certificateRef.current || isLocked) return
    const certificateRect = certificateRef.current.getBoundingClientRect()
    const scale = certificateRect.width / pageWidth
    if (draggingTextId) {
      let nx = (e.clientX - certificateRect.left) / scale - dragOffset.x / scale
      let ny = (e.clientY - certificateRect.top) / scale - dragOffset.y / scale
      nx = Math.max(0, Math.min(nx, pageWidth - 100))
      ny = Math.max(0, Math.min(ny, pageHeight - 50))
      updateField(draggingTextId, { x: nx, y: ny })
    }
    if (resizingTextId) {
      const field = inputFields.find((f) => f.id === resizingTextId)
      if (!field) return
      const deltaX = (e.clientX - dragOffset.x) / scale
      const deltaY = (e.clientY - dragOffset.y) / scale
      const newW = Math.max(50, field.width + deltaX)
      const newH = Math.max(20, field.height + deltaY)
      updateField(resizingTextId, { width: newW, height: newH })
      setDragOffset({ x: e.clientX, y: e.clientY })
    }
    if (draggingImageId) {
      const img = imageFiles.find((i) => i.id === draggingImageId)
      if (!img) return
      let nx = (e.clientX - certificateRect.left) / scale - dragOffset.x / scale
      let ny = (e.clientY - certificateRect.top) / scale - dragOffset.y / scale
      nx = Math.max(0, Math.min(nx, pageWidth - img.width))
      ny = Math.max(0, Math.min(ny, pageHeight - img.height))
      setImageFiles((prev) => prev.map((i) => (i.id === draggingImageId ? { ...i, x: nx, y: ny } : i)))
    }
    if (resizingImageId) {
      const img = imageFiles.find((i) => i.id === resizingImageId)
      if (!img) return
      const deltaX = (e.clientX - dragOffset.x) / scale
      const deltaY = (e.clientY - dragOffset.y) / scale
      const newW = Math.max(30, img.width + deltaX)
      const newH = Math.max(30, img.height + deltaY)
      setImageFiles((prev) => prev.map((i) => (i.id === resizingImageId ? { ...i, width: newW, height: newH } : i)))
      setDragOffset({ x: e.clientX, y: e.clientY })
    }
    if (isDragging) {
      let nx = (e.clientX - certificateRect.left) / scale - dragOffset.x / scale
      let ny = (e.clientY - certificateRect.top) / scale - dragOffset.y / scale
      nx = Math.max(0, Math.min(nx, pageWidth - qrSize.width))
      ny = Math.max(0, Math.min(ny, pageHeight - qrSize.height))
      setQrPosition({ x: nx, y: ny })
    }
    if (resizingQR) {
      const deltaX = (e.clientX - dragOffset.x) / scale
      const deltaY = (e.clientY - dragOffset.y) / scale
      const newW = Math.max(40, Math.min(400, qrSize.width + deltaX))
      const newH = Math.max(40, Math.min(400, qrSize.height + deltaY))
      setQrSize({ width: newW, height: newH })
      setDragOffset({ x: e.clientX, y: e.clientY })
    }
  }
  const handleMouseUp = () => {
    setIsDragging(false)
    setDraggingTextId(null)
    setDraggingImageId(null)
    setResizingImageId(null)
    setResizingQR(false)
    setResizingTextId(null)
  }
  const handleSaveStep1 = async () => {
    if (!bgFile && !bgPreview) {
      showAlert("Upload background first", "warning")
      return
    }
    showConfirm("Merge background & images to upload as one image?", async () => {
      const mergedBgUrl = await mergeBackground()
      showAlert("Background updated! Now add fields.", "success")
    })
  }
  const parseTemplate = (template) => {
    console.log(template, "Parsing template")
    if (!template || typeof template !== "string") {
      console.error("Invalid template")
      return
    }
    try {
      const parser = new DOMParser()
      const doc = parser.parseFromString(template, "text/html")
      const certificateEl = doc.querySelector(".certificate")
      if (!certificateEl) {
        console.error(".certificate element not found in template")
        return
      }
      const styleTag = doc.querySelector("style")
      if (styleTag) {
        const css = styleTag.textContent
       const bgMatch = css.match(/background.*?url\(['"]?([^'"]+)['"]?\)/);
        if (bgMatch?.[1]) {
          console.log("Background URL found:", bgMatch[1])
          setBgPreview(bgMatch[1])
          if (bgMatch[1] === DEFAULT_BACKGROUND_URL || bgMatch[1].includes("backgroudwhite.png")) {
            setUseDefaultBackground(true)
            console.log("[v0] Default background detected in edit mode")
          } else {
            setUseDefaultBackground(false)
          }
          setBackgroundCompleted(true)
        }
        const certRuleMatch = css.match(/\.certificate\s*{\s*([^}]*)}/)
        if (certRuleMatch) {
          const rules = certRuleMatch[1]
          
          // Try to match inches first (new format)
          const widthInchMatch = rules.match(/width:\s*([\d.]+)in/)
          const heightInchMatch = rules.match(/height:\s*([\d.]+)in/)
          
          if (widthInchMatch && heightInchMatch) {
            const parsedInchW = Number.parseFloat(widthInchMatch[1])
            const parsedInchH = Number.parseFloat(heightInchMatch[1])
            
            // Find matching size by inches
            const matchingSize = pageSizeOptions.find((opt) => 
              Math.abs(opt.inchW - parsedInchW) < 0.1 && Math.abs(opt.inchH - parsedInchH) < 0.1
            )
            
            if (matchingSize) {
              setPageSettings({ width: matchingSize.width, height: matchingSize.height })
              setSelectedPageSize(matchingSize.name)
              setCertificateSize(matchingSize.size)
              console.log("[v0] Certificate size restored from inches:", matchingSize.size, `${parsedInchW}in x ${parsedInchH}in`)
            }
          } else {
            // Fallback to pixel format (old format)
            const widthMatch = rules.match(/width:\s*(\d+)px/)
            const heightMatch = rules.match(/height:\s*(\d+)px/)
            if (widthMatch && heightMatch) {
              const parsedWidth = Number.parseInt(widthMatch[1])
              const parsedHeight = Number.parseInt(heightMatch[1])
              setPageSettings({ width: parsedWidth, height: parsedHeight })
              const matchingSize = pageSizeOptions.find((opt) => opt.width === parsedWidth && opt.height === parsedHeight)
              if (matchingSize) {
                setSelectedPageSize(matchingSize.name)
                setCertificateSize(matchingSize.size)
                console.log("[v0] Certificate size restored from pixels:", matchingSize.size)
              }
            }
          }
        }
        const qrRuleMatch = css.match(/\.qr\s*{\s*([^}]*)}/)
        if (qrRuleMatch) {
          const rules = qrRuleMatch[1]
          const left = rules.match(/left:\s*([\d.]+)px/)
          const top = rules.match(/top:\s*([\d.]+)px/)
          const width = rules.match(/width:\s*([\d.]+)px/)
          const height = rules.match(/height:\s*([\d.]+)px/)
          if (left && top && width && height) {
            setQrPosition({
              x: Number.parseFloat(left[1]),
              y: Number.parseFloat(top[1]),
            })
            setQrSize({
              width: Number.parseFloat(width[1]),
              height: Number.parseFloat(height[1]),
            })
            console.log("QR position restored:", {
              x: Number.parseFloat(left[1]),
              y: Number.parseFloat(top[1]),
              width: Number.parseFloat(width[1]),
              height: Number.parseFloat(height[1]),
            })
          }
        }
      }
      const qrEl = certificateEl.querySelector(".qr")
      if (qrEl?.src) {
        console.log("QR URL restored:", qrEl.src)
        setQrUrl(qrEl.src)
        setQrText("")
        setQrVisible(true)
      }
      certificateEl.querySelectorAll(".text-field").forEach((el) => {
        const text = (el.textContent || "").trim()
        const style = el.getAttribute("style") || ""
        const styles = {}
        style.split(";").forEach((s) => {
          const [k, v] = s.split(":").map((x) => x.trim())
          if (k && v) styles[k] = v
        })
        const updates = {
          visible: true,
          x: Number.parseInt(styles.left) || 150,
          y: Number.parseInt(styles.top) || 150,
          width: Number.parseInt(styles.width) || 200,
          height: Number.parseInt(styles.height) || 40,
          fontSize: Number.parseInt(styles["font-size"]) || 16,
          fontFamily: (styles["font-family"] || "Arial").replace(/['"]/g, "").split(",")[0].trim(),
          fontWeight: styles["font-weight"] === "bold" ? "700" : styles["font-weight"] || "400",
          color: styles.color || "#000000",
          textAlign: styles["text-align"] || "center",
        }
        if (text.startsWith("{{") && text.endsWith("}}")) {
          const fieldKey = text.slice(2, -2).trim()
          const field = inputFields.find((f) => f.fieldKey === fieldKey)
          if (!field) return
          updateField(field.id, updates)
        } else {
          const customCount = inputFields.filter((f) => !f.fieldKey).length + 1
          const newId = `custom_${Date.now()}`
          const newField = {
            id: newId,
            label: `Custom Text ${customCount}`,
            text: text,
            ...updates,
          }
          setInputFields((prev) => [...prev, newField])
        }
      })
    } catch (err) {
      console.error("parseTemplate crashed:", err)
    }
  }
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ticketDropdownRef.current && !ticketDropdownRef.current.contains(event.target)) {
        setIsTicketDropdownOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  useEffect(() => {
    const payload = { event_id: EventID }
    GetTicketsByID(payload).then((res) => {
      setTickets(res.data.tickets || [])
      console.log(res.data.tickets, "res")
    })
  }, [])
  useEffect(() => {
    if (!location.state?.state) return
    const { isEdit, certificate } = location.state.state
    console.log(certificate, "uaysyfduy")
    if (isEdit && certificate?.template) {
      setIsEdit(true)
      const defautlbg = certificate?.default_bg === 0 ? false : true
      console.log(defautlbg, "defautlbg")
      if (certificate.certificate_size) {
  setCertificateSize(certificate.certificate_size)  // NEW
  console.log("[v0] Certificate size restored from data:", certificate.certificate_size)
}
      setUseDefaultBackground(certificate?.default_bg === 0 ? false : true)
      setCertificateId(certificate.id)
      setCertificateTitle(certificate.title || "Untitled Certificate")
      setIsLocked(false)
   
    if (certificate.event_ticket) {
 
      if (Array.isArray(certificate.event_ticket)) {
        setSelectedTickets(certificate.event_ticket.length > 0 ? certificate.event_ticket : [0])
      } else if (typeof certificate.event_ticket === 'string') {
   
        const ticketIds = certificate.event_ticket.split(',').map(id => Number(id.trim())).filter(id => !isNaN(id))
        setSelectedTickets(ticketIds.length > 0 ? ticketIds : [0])
      } else {

        setSelectedTickets([certificate.event_ticket])
      }
    } else {

      setSelectedTickets([0])
    }
      setQrText("example link")
      parseTemplate(certificate.template)
      setTimeout(() => {
        setPageSizeConfirmed(true)
        setBackgroundCompleted(true)
      }, 100)
    }
  }, [location.state])
const handleSaveTemplate = async () => {
  if (!certificateTitle.trim()) {
    showAlert("Please enter a Template Name", "warning")
    return
  }
  showConfirm("Save this template?", async () => {
    setIsGenerating(true)
    try {
      let currentBgPreview = bgPreview
      if (imageFiles.length > 0) {
        currentBgPreview = await mergeBackground()
      }
      let finalQrUrl = null
      if (qrText.trim() && qrVisible) {
        if (!qrImage) throw new Error("QR code not generated. Please wait or re-enter URL.")
        const qrBlob = await (await fetch(qrImage)).blob()
        const qrFile = new File([qrBlob], `qr-${Date.now()}.png`, {
          type: "image/png",
        })
        const qrResponse = await uploadFilesAWS([qrFile])
        const qrUrls = qrResponse?.data?.uploadedUrls || qrResponse?.uploadedUrls || {}
        finalQrUrl = Object.values(qrUrls).flat().pop()
      } else if (qrUrl && qrVisible) {
        finalQrUrl = qrUrl
      }
      const visibleFields = inputFields.filter((f) => f.visible)
      const htmlCode = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>${certificateTitle}</title>
  <style>
    * { margin:0; padding:0; box-sizing:border-box; }
    body { background:#FFFFFF; display:flex; justify-content:center; align-items:center; min-height:100vh; }
    .certificate {
      position:relative;
      width:${CERTIFICATE_SIZE_INCHES.w}in;
      height:${CERTIFICATE_SIZE_INCHES.h}in;
      background:url('${currentBgPreview}') center/cover no-repeat;
      overflow:hidden;
  
    }
    .qr {
      position:absolute;
      left:${qrPosition.x}px;
      top:${qrPosition.y}px;
      width:${qrSize.width}px;
      height:${qrSize.height}px;
      pointer-events:none;
    }
    .text-field {
      position:absolute;
      padding:0 14px;
      display:flex;
      align-items:center;
      background:transparent;
      border:none;
      outline:none;
      pointer-events:none;
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
      line-height:1.2;
    }
  </style>
</head>
<body>
  <div class="certificate">
    ${finalQrUrl ? `<img src="${finalQrUrl}" class="qr" alt="QR Code" crossorigin="anonymous">` : ""}
    ${visibleFields
      .map(
        (field) => `<div class="text-field"
                    style="
                      left:${field.x}px;
                      top:${field.y}px;
                      width:${field.width}px;
                      height:${field.height}px;
                      font-size:${field.fontSize}px;
                      font-family:'${field.fontFamily}',sans-serif;
                      font-weight:${field.fontWeight};
                      color:${field.color};
                      justify-content:${field.textAlign === "center" ? "center" : field.textAlign === "right" ? "flex-end" : "flex-start"};
                    ">
                    ${field.fieldKey ? `{{${field.fieldKey}}}` : field.text}
                  </div>`,
      )
      .join("")}
  </div>
</body>
</html>`.trim()
      if (isEdit && certificateId) {
        await UpdateCertificate({
          id: certificateId,
          title: certificateTitle,
          template: htmlCode,
          event_ticket: selectedTickets.includes(0) ? 0 : selectedTickets,
          default_bg: useDefaultBackground,
          certificate_size: certificateSize,
        })
        showToast(`Success! Template updated: "${certificateTitle}"`, "success")
        setTimeout(() => {
          history.push("/events/admin/certificate-list")
        }, 1000)
      } else {
        await createCertificate({
          title: certificateTitle,
          template: htmlCode,
          event_ticket: selectedTickets.includes(0) ? 0 : selectedTickets,
          default_bg: useDefaultBackground,
          certificate_size: certificateSize,
        })
        showToast(`Success! Template saved: "${certificateTitle}"`, "success")
        setTimeout(() => {
          history.push("/events/admin/certificate-list")
        }, 1000)
      }
      setGeneratedHtml(htmlCode)
      setIsLocked(true)
    } catch (err) {
      console.error(err)
      showToast("Failed to save: " + (err.message || "Unknown error"), "error")
    } finally {
      setIsGenerating(false)
    }
  })
}
  const copyHtmlToClipboard = () => {
    navigator.clipboard.writeText(generatedHtml)
    showAlert("HTML code copied!", "success")
  }
  const handleResetAll = () => {
    showConfirm("Reset everything?", () => {
      window.location.reload()
    })
  }
  const handlePageSizeChange = (name) => {
    const opt = pageSizeOptions.find((p) => p.name === name)
    if (opt) {
      setPageSettings({ width: opt.width, height: opt.height })
      setSelectedPageSize(name)
      setCertificateSize(opt.size)
      console.log("[v0] Page size changed to:", name, "size:", opt.size, "inches:", opt.inchW, "x", opt.inchH)
    }
  }
  const sidebarStyles = {
    container: {
      width: "320px",
      backgroundColor: "#ffffff",
      borderRadius: "16px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
      display: "flex",
      flexDirection: "column",
      height: "calc(100vh - 100px)",
      overflow: "hidden",
    },
    header: {
      background: "linear-gradient(135deg, #1e3a5f 0%, #2d4a6f 100%)",
      padding: "20px",
      color: "#ffffff",
      borderRadius: "16px 16px 0 0",
      display: "flex",
      alignItems: "center",
      gap: "12px",
      flexShrink: 0,
    },
    headerIcon: {
      width: "44px",
      height: "44px",
      backgroundColor: "rgba(255,255,255,0.2)",
      borderRadius: "12px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    headerTitle: {
      fontSize: "18px",
      fontWeight: "700",
      margin: 0,
    },
    headerSubtitle: {
      fontSize: "12px",
      opacity: 0.8,
      margin: 0,
    },
    tabContainer: {
      display: "flex",
      padding: "16px",
      gap: "8px",
      borderBottom: "1px solid #e5e7eb",
      flexShrink: 0,
    },
    tab: {
      flex: 1,
      padding: "10px 16px",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: "600",
      transition: "all 0.2s",
      backgroundColor: "#f3f4f6",
      color: "#6b7280",
    },
    tabActive: {
      backgroundColor: "#1e3a5f",
      color: "#ffffff",
    },
    tabDisabled: {
      opacity: 0.5,
      cursor: "not-allowed",
    },
    scrollableContent: {
      flex: 1,
      overflowY: "auto",
      minHeight: 0,
      padding: "16px",
    },
    fieldList: {
      padding: "0",
    },
    fieldItem: {
      marginBottom: "12px",
      border: "1px solid #e2e8f0",
      borderRadius: "14px",
      backgroundColor: "#ffffff",
      overflow: "hidden",
      transition: "all 0.25s ease",
      boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
    },
    fieldItemActive: {
      borderColor: "#1e3a5f",
      boxShadow: "0 0 0 3px rgba(30, 58, 95, 0.1), 0 4px 12px rgba(0,0,0,0.08)",
    },
    fieldHeader: {
      display: "flex",
      alignItems: "center",
      padding: "16px 18px",
      cursor: "pointer",
      transition: "background-color 0.15s ease",
    },
    fieldIcon: {
      width: "42px",
      height: "42px",
      marginRight: "14px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#fef3c7",
      borderRadius: "12px",
      color: "#f59e0b",
      fontSize: "14px",
      fontWeight: "600",
      transition: "all 0.2s ease",
    },
    fieldIconActive: {
      backgroundColor: "#f59e0b",
      color: "#ffffff",
    },
    fieldLabel: {
      flex: 1,
      fontSize: "14px",
      color: "#334155",
      fontWeight: "500",
    },
    toggleSwitch: {
      width: "52px",
      height: "28px",
      backgroundColor: "#e2e8f0",
      borderRadius: "14px",
      cursor: "pointer",
      position: "relative",
      transition: "all 0.3s ease",
      marginLeft: "auto",
      flexShrink: 0,
    },
    toggleSwitchActive: {
      backgroundColor: "#1e3a5f",
    },
    toggleKnob: {
      width: "22px",
      height: "22px",
      backgroundColor: "#ffffff",
      borderRadius: "50%",
      position: "absolute",
      top: "3px",
      left: "3px",
      transition: "all 0.3s ease",
      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
    },
    toggleKnobActive: {
      left: "27px",
    },
    designPanel: {
      padding: "18px 20px",
      backgroundColor: "#f8fafc",
      borderTop: "1px solid #e2e8f0",
    },
    designRow: {
      display: "flex",
      gap: "14px",
      marginBottom: "16px",
    },
    designGroup: {
      flex: 1,
    },
    sectionTitle: {
      fontSize: "11px",
      fontWeight: "700",
      color: "#64748b",
      marginBottom: "16px",
      textTransform: "uppercase",
      letterSpacing: "0.8px",
    },
    label: {
      fontSize: "11px",
      fontWeight: "600",
      color: "#64748b",
      marginBottom: "8px",
      display: "block",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    input: {
      width: "100%",
      padding: "12px 14px",
      border: "1px solid #e2e8f0",
      borderRadius: "10px",
      fontSize: "14px",
      color: "#334155",
      outline: "none",
      backgroundColor: "#ffffff",
      transition: "all 0.2s ease",
      marginBottom: "16px",
    },
    select: {
      width: "100%",
      padding: "12px 14px",
      border: "1px solid #e2e8f0",
      borderRadius: "10px",
      fontSize: "14px",
      color: "#334155",
      backgroundColor: "#ffffff",
      outline: "none",
      cursor: "pointer",
      transition: "all 0.2s ease",
      marginBottom: "16px",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%2364748b' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 14px center",
      paddingRight: "40px",
    },
    colorRow: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    colorInput: {
      width: "46px",
      height: "46px",
      border: "2px solid #e2e8f0",
      borderRadius: "10px",
      cursor: "pointer",
      padding: "3px",
    },
    alignGroup: {
      display: "flex",
      gap: "8px",
    },
    alignButton: {
      flex: 1,
      padding: "12px",
      border: "1px solid #e2e8f0",
      backgroundColor: "#ffffff",
      borderRadius: "10px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.2s ease",
      color: "#64748b",
    },
    alignButtonActive: {
      backgroundColor: "#1e3a5f",
      borderColor: "#1e3a5f",
      color: "#ffffff",
    },
    bgButton: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "12px",
      padding: "16px 18px",
      border: "2px dashed #cbd5e1",
      borderRadius: "14px",
      backgroundColor: "#f8fafc",
      cursor: "pointer",
      fontSize: "14px",
      color: "#64748b",
      width: "100%",
      transition: "all 0.25s ease",
      fontWeight: "500",
    },
    bgStatus: {
      fontSize: "12px",
      color: "rgb(49, 113, 156) 100%)",
      marginTop: "12px",
      display: "flex",
      alignItems: "center",
      gap: "6px",
    },
    saveButtonContainer: {
      padding: "16px",
      borderTop: "1px solid #e5e7eb",
      backgroundColor: "#f9fafb",
      flexShrink: 0,
    },
    saveButton: {
      width: "100%",
      padding: "14px 20px",
      backgroundColor: "#1e3a5f",
      color: "#ffffff",
      border: "none",
      borderRadius: "12px",
      fontSize: "15px",
      fontWeight: "600",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "10px",
      transition: "all 0.2s",
      boxShadow: "0 4px 12px rgba(30, 58, 95, 0.3)",
    },
    saveButtonUpdate: {
      backgroundColor: "#3b82f6",
      boxShadow: "0 4px 12px rgba(59, 130, 246, 0.3)",
    },
  }
  const handleTicketToggle = (ticketId) => {
    if (ticketId === 0) {
      // If "All Tickets" is clicked
      setSelectedTickets([0])
    } else {
      // Remove "All Tickets" if selecting specific tickets
      const newSelection = selectedTickets.includes(0)
        ? [ticketId]
        : selectedTickets.includes(ticketId)
          ? selectedTickets.filter((id) => id !== ticketId)
          : [...selectedTickets, ticketId]

      // If no tickets selected, default to "All Tickets"
      setSelectedTickets(newSelection.length === 0 ? [0] : newSelection)
    }
  }

  const getTicketDisplayText = () => {
    if (selectedTickets.includes(0) || selectedTickets.length === 0) {
      return "All Tickets"
    }
    if (selectedTickets.length === 1) {
      const ticket = tickets.find((t) => t.id === selectedTickets[0])
      return ticket?.ticket_name || "All Tickets"
    }
    return `${selectedTickets.length} Tickets Selected`
  }
  const renderBackgroundTab = () => (
    <>
      <div style={sidebarStyles.sectionTitle}>Template Settings</div>
      <label style={sidebarStyles.label}>Template Name</label>
      <input
        type="text"
        style={sidebarStyles.input}
        value={certificateTitle}
        onChange={(e) => setCertificateTitle(e.target.value)}
        disabled={isLocked}
        placeholder="New Certificate Template"
      />
      <label style={sidebarStyles.label}>Canvas Size</label>
      <select
        style={sidebarStyles.select}
        value={selectedPageSize}
        onChange={(e) => handlePageSizeChange(e.target.value)}
        disabled={isLocked || backgroundCompleted}
      >
        {pageSizeOptions.map((opt) => (
          <option key={opt.name} value={opt.name}>
            {opt.name}
          </option>
        ))}
      </select>
      {/* Updated ticket selection UI to use multiple select dropdown with badges */}
      <label style={sidebarStyles.label}>Ticket</label>
      <div
        ref={ticketDropdownRef}
        style={{
          position: "relative",
          marginBottom: "16px",
        }}
      >
        <button
          onClick={() => setIsTicketDropdownOpen(!isTicketDropdownOpen)}
          disabled={isLocked}
          style={{
            width: "100%",
            padding: "8px 12px",
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            borderRadius: "4px",
            textAlign: "left",
            cursor: isLocked ? "not-allowed" : "pointer",
            opacity: isLocked ? 0.6 : 1,
          }}
        >
          {getTicketDisplayText()}
        </button>

        {isTicketDropdownOpen && (
          <div
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              right: 0,
              backgroundColor: "#fff",
              border: "1px solid #ccc",
              borderRadius: "4px",
              marginTop: "4px",
              maxHeight: "300px",
              overflowY: "auto",
              zIndex: 10,
              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            }}
          >
            <label
              style={{
                display: "flex",
                alignItems: "center",
                padding: "10px 12px",
                borderBottom: "1px solid #eee",
                cursor: "pointer",
              }}
            >
              <input
                type="checkbox"
                checked={selectedTickets.includes(0)}
                onChange={() => handleTicketToggle(0)}
                style={{ marginRight: "8px", cursor: "pointer" }}
              />
              All Tickets
            </label>

            {tickets.map((ticket) => (
              <label
                key={ticket.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "10px 12px",
                  borderBottom: "1px solid #eee",
                  cursor: "pointer",
                }}
              >
                <input
                  type="checkbox"
                  checked={selectedTickets.includes(ticket.id)}
                  onChange={() => handleTicketToggle(ticket.id)}
                  style={{ marginRight: "8px", cursor: "pointer" }}
                />
                {ticket.ticket_name}
              </label>
            ))}
          </div>
        )}

{selectedTickets.length > 0 && !selectedTickets.includes(0) && (
  <div style={{ marginTop: "8px", display: "flex", flexWrap: "wrap", gap: "4px", alignItems: "center" }}>
    {selectedTickets.slice(-3).map((ticketId) => {
      const ticket = tickets.find((t) => t.id === ticketId)
      return (
        <span
          key={ticketId}
          style={{
            display: "inline-flex",
            alignItems: "center",
            backgroundColor: "#e0e7ff",
            color: "#3730a3",
            padding: "4px 8px",
            borderRadius: "12px",
            fontSize: "12px",
            gap: "4px",
          }}
        >
          {ticket?.ticket_name || "Unknown"}
          <button
            onClick={() => handleTicketToggle(ticketId)}
            style={{
              background: "none",
              border: "none",
              color: "#3730a3",
              cursor: "pointer",
              fontSize: "14px",
              padding: "0",
            }}
          >
            ×
          </button>
        </span>
      )
    })}
    {selectedTickets.length > 3 && (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          backgroundColor: "#f3f4f6",
          color: "#6b7280",
          padding: "4px 8px",
          borderRadius: "12px",
          fontSize: "12px",
        }}
      >
        +{selectedTickets.length - 3} more
      </span>
    )}
  </div>
)}
      </div>
      <div style={sidebarStyles.sectionTitle}>Background Image</div>
      {(!backgroundCompleted || isEdit) && (
        <div
          style={{
            marginBottom: "16px",
            padding: "16px",
            backgroundColor: "#f0f9ff",
            borderRadius: "12px",
            border: "1px solid #bfdbfe",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "6px",
            }}
          >
            <div style={{ flex: 1 }}>
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#1e3a5f",
                  marginBottom: "4px",
                }}
              >
                Use Default Background
              </div>
              <div style={{ fontSize: "11px", color: "#64748b" }}>Quick start with preset design</div>
            </div>
            <div
              style={{
                ...sidebarStyles.toggleSwitch,
                ...(useDefaultBackground ? sidebarStyles.toggleSwitchActive : {}),
              }}
              onClick={handleDefaultBackgroundToggle}
            >
              <div
                style={{
                  ...sidebarStyles.toggleKnob,
                  ...(useDefaultBackground ? sidebarStyles.toggleKnobActive : {}),
                }}
              />
            </div>
          </div>
        </div>
      )}
      {(!backgroundCompleted || isEdit) && !useDefaultBackground && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            margin: "16px 0",
          }}
        >
          <div style={{ flex: 1, height: "1px", backgroundColor: "#e2e8f0" }} />
          <span style={{ fontSize: "12px", color: "#64748b", fontWeight: "600" }}>OR</span>
          <div style={{ flex: 1, height: "1px", backgroundColor: "#e2e8f0" }} />
        </div>
      )}
      {(!backgroundCompleted || isEdit) && !useDefaultBackground && (
        <>
          <input
            ref={bgImageInputRef}
            type="file"
            accept="image/*"
            onChange={(e) => {
              const file = e.target.files[0]
              if (file) {
                const reader = new FileReader()
                reader.onload = (ev) => {
                  setBgFile(file)
                  setBgPreview(ev.target.result)
                  setBackgroundUploadStatus("success")
                  setBackgroundCompleted(false)
                  setUseDefaultBackground(false)
                }
                reader.readAsDataURL(file)
              }
            }}
            style={{ display: "none" }}
          />
          <button style={sidebarStyles.bgButton} onClick={() => bgImageInputRef.current.click()} disabled={isLocked}>
            <MdUpload size={20} />
            {bgPreview ? "Change Background" : "Upload Background"}
          </button>
        </>
      )}
      {bgPreview && (
        <div style={sidebarStyles.bgStatus}>
          <span
            style={{
              width: "8px",
              height: "8px",
              backgroundColor: "#184778",
              borderRadius: "50%",
              display: "inline-block",
            }}
          ></span>
          Background image loaded
        </div>
      )}
      {bgPreview && (!backgroundCompleted || isEdit) && (
        <button
          style={{
            ...sidebarStyles.bgButton,
            color: "#dc2626",
            borderColor: "#fecaca",
            marginTop: "12px",
          }}
          onClick={handleRemoveBackground}
          disabled={isLocked}
        >
          <IoClose size={18} />
          Remove Background
        </button>
      )}
      {backgroundCompleted && !isEdit && (
        <button
          style={{
            ...sidebarStyles.bgButton,
            color: "#dc2626",
            borderColor: "#fecaca",
            marginTop: "12px",
          }}
          onClick={handleChangeBackground}
          disabled={isLocked}
        >
          <IoClose size={18} />
          Reset Background
        </button>
      )}
      {!isLocked && (backgroundUploadStatus === "success" || useDefaultBackground || (isEdit && bgPreview)) && (
        <>
          <div style={{ ...sidebarStyles.sectionTitle, marginTop: "24px" }}>Additional Images</div>
          <input
            ref={imageInputRef}
            type="file"
            accept="image/*"
            multiple
            onChange={(e) => {
              Array.from(e.target.files).forEach((file) => {
                const reader = new FileReader()
                reader.onload = (ev) => {
                  const img = new Image()
                  img.onload = () => {
                    const max = 200
                    let w = img.width,
                      h = img.height
                    if (w > max || h > max) {
                      const ratio = Math.min(max / w, max / h)
                      w *= ratio
                      h *= ratio
                    }
                    setImageFiles((prev) => [
                      ...prev,
                      {
                        id: Date.now() + Math.random(),
                        file,
                        preview: ev.target.result,
                        x: 50,
                        y: 50,
                        width: w,
                        height: h,
                      },
                    ])
                  }
                  img.src = ev.target.result
                }
                reader.readAsDataURL(file)
              })
            }}
            style={{ display: "none" }}
          />
          <button style={sidebarStyles.bgButton} onClick={() => imageInputRef.current.click()}>
            <MdUpload size={20} />
            Upload Images
          </button>
          {imageFiles.length > 0 && (
            <button
              style={{
                ...sidebarStyles.bgButton,
                color: "#dc2626",
                borderColor: "#fecaca",
                marginTop: "12px",
              }}
              onClick={handleClearAllImages}
            >
              <MdDelete size={18} />
              Clear All ({imageFiles.length})
            </button>
          )}
        </>
      )}
      {!backgroundCompleted && (backgroundUploadStatus === "success" || useDefaultBackground) && (
        <button
          style={{
            ...sidebarStyles.saveButton,
            background: "linear-gradient(135deg, rgb(24, 71, 120) 0%, rgb(49, 113, 156) 100%)",
            marginTop: "20px",
          }}
          onClick={handleSaveStep1}
          disabled={isGenerating}
        >
          {isGenerating ? "Processing..." : "Confirm Background"}
        </button>
      )}
    </>
  )
  const renderFieldsTab = () => (
    <>
      <div style={sidebarStyles.sectionTitle}>Available Fields</div>
      <div style={sidebarStyles.fieldList}>
        {inputFields
          .filter((field) => field.fieldKey)
          .map((field) => (
            <div
              key={field.id}
              style={{
                ...sidebarStyles.fieldItem,
                ...(field.visible ? sidebarStyles.fieldItemActive : {}),
              }}
            >
              <div
                style={sidebarStyles.fieldHeader}
                onClick={() => {
                  if (!isLocked && backgroundCompleted) {
                    setSelectedFieldId(selectedFieldId === field.id ? null : field.id)
                  }
                }}
              >
                <div
                  style={{
                    ...sidebarStyles.fieldIcon,
                    ...(field.visible ? sidebarStyles.fieldIconActive : {}),
                  }}
                >
                  <FaCertificate size={16} />
                </div>
                <span style={sidebarStyles.fieldLabel}>{field.label}</span>
                <div
                  style={{
                    ...sidebarStyles.toggleSwitch,
                    ...(field.visible ? sidebarStyles.toggleSwitchActive : {}),
                  }}
                  onClick={(e) => {
                    e.stopPropagation()
                    if (!isLocked && backgroundCompleted) {
                      toggleFieldVisibility(field.id)
                    }
                  }}
                >
                  <div
                    style={{
                      ...sidebarStyles.toggleKnob,
                      ...(field.visible ? sidebarStyles.toggleKnobActive : {}),
                    }}
                  />
                </div>
              </div>
              {field.visible && selectedFieldId === field.id && (
                <div style={sidebarStyles.designPanel}>
                  <div style={sidebarStyles.designRow}>
                    <div style={sidebarStyles.designGroup}>
                      <label style={sidebarStyles.label}>Font Size</label>
                      <select
                        style={sidebarStyles.select}
                        value={field.fontSize}
                        onChange={(e) =>
                          updateField(field.id, {
                            fontSize: Number.parseInt(e.target.value),
                          })
                        }
                        disabled={isLocked}
                      >
                        {[
                          12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 36, 40, 44, 48, 52, 56, 60, 64, 72, 80, 96, 120,
                        ].map((size) => (
                          <option key={size} value={size}>
                            {size}px
                          </option>
                        ))}
                      </select>
                    </div>
                    <div style={sidebarStyles.designGroup}>
                      <label style={sidebarStyles.label}>Font Weight</label>
                      <select
                        style={sidebarStyles.select}
                        value={field.fontWeight}
                        onChange={(e) => updateField(field.id, { fontWeight: e.target.value })}
                        disabled={isLocked}
                      >
                        {fontWeights.map((w) => (
                          <option key={w.value} value={w.value}>
                            {w.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <label style={sidebarStyles.label}>Font Family</label>
                  <select
                    style={{ ...sidebarStyles.select, fontFamily: field.fontFamily }}
                    value={field.fontFamily}
                    onChange={(e) => updateField(field.id, { fontFamily: e.target.value })}
                    disabled={isLocked}
                  >
                    {fontFamilies.map((font) => (
                      <option key={font} value={font} style={{ fontFamily: font }}>
                        {font}
                      </option>
                    ))}
                  </select>
                  <label style={sidebarStyles.label}>Color</label>
                  <div style={sidebarStyles.colorRow}>
                    <input
                      type="color"
                      style={sidebarStyles.colorInput}
                      value={field.color}
                      onChange={(e) => updateField(field.id, { color: e.target.value })}
                      disabled={isLocked}
                    />
                    <input
                      type="text"
                      style={{ ...sidebarStyles.input, flex: 1, marginBottom: 0 }}
                      value={field.color}
                      onChange={(e) => updateField(field.id, { color: e.target.value })}
                      disabled={isLocked}
                    />
                  </div>
                  <label style={{ ...sidebarStyles.label, marginTop: "16px" }}>Text Align</label>
                  <div style={sidebarStyles.alignGroup}>
                    {["left", "center", "right"].map((align) => (
                      <button
                        key={align}
                        style={{
                          ...sidebarStyles.alignButton,
                          ...(field.textAlign === align ? sidebarStyles.alignButtonActive : {}),
                        }}
                        onClick={() => updateField(field.id, { textAlign: align })}
                        disabled={isLocked}
                      >
                        {align === "left" && <MdFormatAlignLeft size={18} />}
                        {align === "center" && <MdFormatAlignCenter size={18} />}
                        {align === "right" && <MdFormatAlignRight size={18} />}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        {/* QR Code field */}
        <div
          style={{
            ...sidebarStyles.fieldItem,
            ...(qrVisible ? sidebarStyles.fieldItemActive : {}),
          }}
        >
          <div
            style={sidebarStyles.fieldHeader}
            onClick={() => {
              if (!isLocked && backgroundCompleted) {
                setQrVisible(!qrVisible)
              }
            }}
          >
            <div
              style={{
                ...sidebarStyles.fieldIcon,
                ...(qrVisible ? sidebarStyles.fieldIconActive : {}),
              }}
            >
              <MdQrCode size={18} />
            </div>
            <span style={sidebarStyles.fieldLabel}>QR Code</span>
            <div
              style={{
                ...sidebarStyles.toggleSwitch,
                ...(qrVisible ? sidebarStyles.toggleSwitchActive : {}),
              }}
              onClick={(e) => {
                e.stopPropagation()
                if (!isLocked && backgroundCompleted) {
                  setQrVisible(!qrVisible)
                }
              }}
            >
              <div
                style={{
                  ...sidebarStyles.toggleKnob,
                  ...(qrVisible ? sidebarStyles.toggleKnobActive : {}),
                }}
              />
            </div>
          </div>
        </div>
        {/* Custom Fields Section */}
        <div style={{ ...sidebarStyles.sectionTitle, marginTop: "24px" }}>Custom Fields</div>
        <button
          style={{ ...sidebarStyles.bgButton, marginBottom: "16px" }}
          onClick={addCustomField}
          disabled={isLocked || !backgroundCompleted}
        >
          <MdUpload size={20} />
          Add Custom Text
        </button>
        {inputFields
          .filter((field) => !field.fieldKey)
          .map((field) => (
            <div
              key={field.id}
              style={{
                ...sidebarStyles.fieldItem,
                ...(field.visible ? sidebarStyles.fieldItemActive : {}),
              }}
            >
              <div
                style={sidebarStyles.fieldHeader}
                onClick={() => {
                  if (!isLocked && backgroundCompleted) {
                    setSelectedFieldId(selectedFieldId === field.id ? null : field.id)
                  }
                }}
              >
                <div
                  style={{
                    ...sidebarStyles.fieldIcon,
                    ...(field.visible ? sidebarStyles.fieldIconActive : {}),
                  }}
                >
                  <FaCertificate size={16} />
                </div>
                <span style={sidebarStyles.fieldLabel}>{field.label}</span>
                <div
                  style={{
                    ...sidebarStyles.toggleSwitch,
                    ...(field.visible ? sidebarStyles.toggleSwitchActive : {}),
                  }}
                  onClick={(e) => {
                    e.stopPropagation()
                    if (!isLocked && backgroundCompleted) {
                      toggleFieldVisibility(field.id)
                    }
                  }}
                >
                  <div
                    style={{
                      ...sidebarStyles.toggleKnob,
                      ...(field.visible ? sidebarStyles.toggleKnobActive : {}),
                    }}
                  />
                </div>
              </div>
              {field.visible && selectedFieldId === field.id && (
                <div style={sidebarStyles.designPanel}>
                  <div style={{ marginBottom: "16px" }}>
                    <label style={sidebarStyles.label}>Custom Text</label>
                    <input
                      type="text"
                      style={sidebarStyles.input}
                      value={field.text}
                      onChange={(e) => updateField(field.id, { text: e.target.value })}
                      disabled={isLocked}
                    />
                  </div>
                  <div style={sidebarStyles.designRow}>
                    <div style={sidebarStyles.designGroup}>
                      <label style={sidebarStyles.label}>Font Size</label>
                      <select
                        style={sidebarStyles.select}
                        value={field.fontSize}
                        onChange={(e) =>
                          updateField(field.id, {
                            fontSize: Number.parseInt(e.target.value),
                          })
                        }
                        disabled={isLocked}
                      >
                        {[
                          12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 36, 40, 44, 48, 52, 56, 60, 64, 72, 80, 96, 120,
                        ].map((size) => (
                          <option key={size} value={size}>
                            {size}px
                          </option>
                        ))}
                      </select>
                    </div>
                    <div style={sidebarStyles.designGroup}>
                      <label style={sidebarStyles.label}>Font Weight</label>
                      <select
                        style={sidebarStyles.select}
                        value={field.fontWeight}
                        onChange={(e) => updateField(field.id, { fontWeight: e.target.value })}
                        disabled={isLocked}
                      >
                        {fontWeights.map((w) => (
                          <option key={w.value} value={w.value}>
                            {w.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <label style={sidebarStyles.label}>Font Family</label>
                  <select
                    style={{ ...sidebarStyles.select, fontFamily: field.fontFamily }}
                    value={field.fontFamily}
                    onChange={(e) => updateField(field.id, { fontFamily: e.target.value })}
                    disabled={isLocked}
                  >
                    {fontFamilies.map((font) => (
                      <option key={font} value={font} style={{ fontFamily: font }}>
                        {font}
                      </option>
                    ))}
                  </select>
                  <label style={sidebarStyles.label}>Color</label>
                  <div style={sidebarStyles.colorRow}>
                    <input
                      type="color"
                      style={sidebarStyles.colorInput}
                      value={field.color}
                      onChange={(e) => updateField(field.id, { color: e.target.value })}
                      disabled={isLocked}
                    />
                    <input
                      type="text"
                      style={{ ...sidebarStyles.input, flex: 1, marginBottom: 0 }}
                      value={field.color}
                      onChange={(e) => updateField(field.id, { color: e.target.value })}
                      disabled={isLocked}
                    />
                  </div>
                  <label style={{ ...sidebarStyles.label, marginTop: "16px" }}>Text Align</label>
                  <div style={sidebarStyles.alignGroup}>
                    {["left", "center", "right"].map((align) => (
                      <button
                        key={align}
                        style={{
                          ...sidebarStyles.alignButton,
                          ...(field.textAlign === align ? sidebarStyles.alignButtonActive : {}),
                        }}
                        onClick={() => updateField(field.id, { textAlign: align })}
                        disabled={isLocked}
                      >
                        {align === "left" && <MdFormatAlignLeft size={18} />}
                        {align === "center" && <MdFormatAlignCenter size={18} />}
                        {align === "right" && <MdFormatAlignRight size={18} />}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
      </div>
    </>
  )
  return (
    <div style={{ minHeight: "100vh", marginTop: "22px" }}>
      <ToastMessage />
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-11"></div>
          <div className="col-md-1">
            {" "}
            <Button
              className="primary"
              onClick={() => {
                history.push("/events/admin/certificate-list")
              }}
            >
              back
            </Button>
          </div>
        </div>
        <div className="row">
          <div className="col-auto p-3">
            <div style={sidebarStyles.container}>
              <div style={sidebarStyles.header}>
                <div style={sidebarStyles.headerIcon}>
                  <FaCertificate size={22} />
                </div>
                <div>
                  <h5 style={sidebarStyles.headerTitle}>Certificate Designer</h5>
                  <p style={sidebarStyles.headerSubtitle}>Create your template</p>
                </div>
              </div>
              <div style={sidebarStyles.tabContainer}>
                <button
                  style={{
                    ...sidebarStyles.tab,
                    ...(activeTab === "background" ? sidebarStyles.tabActive : {}),
                  }}
                  onClick={() => setActiveTab("background")}
                >
                  Background
                </button>
                <button
                  style={{
                    ...sidebarStyles.tab,
                    ...(activeTab === "fields" ? sidebarStyles.tabActive : {}),
                    ...(!backgroundCompleted ? sidebarStyles.tabDisabled : {}),
                  }}
                  onClick={() => backgroundCompleted && setActiveTab("fields")}
                  disabled={!backgroundCompleted}
                >
                  Fields
                </button>
              </div>
              <div style={sidebarStyles.scrollableContent}>
                {/* Background Tab Content */}
                {activeTab === "background" && renderBackgroundTab()}
                {/* Fields Tab Content */}
                {activeTab === "fields" && renderFieldsTab()}
              </div>
              {backgroundCompleted && (
                <div style={sidebarStyles.saveButtonContainer}>
                  <button
                    style={{
                      ...sidebarStyles.saveButton,
                      ...(isEdit ? sidebarStyles.saveButtonUpdate : {}),
                    }}
                    onClick={handleSaveTemplate}
                    disabled={isGenerating || isLocked}
                  >
                    {isGenerating ? (
                      <>
                        <span
                          style={{
                            width: "18px",
                            height: "18px",
                            border: "2px solid rgba(255,255,255,0.3)",
                            borderTopColor: "#ffffff",
                            borderRadius: "50%",
                            animation: "spin 0.8s linear infinite",
                          }}
                        />
                        Saving...
                      </>
                    ) : (
                      <>
                        {isEdit ? <MdEdit size={18} /> : <MdSave size={18} />}
                        {isEdit ? "Update Template" : "Save Template"}
                      </>
                    )}
                  </button>
                </div>
              )}
            </div>
          </div>
          {/* Canvas area */}
          <div className="col">
            <div className="card border-0 shadow-sm rounded-3 overflow-hidden" style={{ margin: "20px" }}>
              <div
                className="card-body p-4 bg-white d-flex justify-content-center align-items-center"
                style={{ minHeight: "80vh" }}
              >
                <div
                  ref={certificateRef}
                  className="position-relative rounded-3 overflow-hidden shadow-lg certificate"
                  style={{
                    width: pageWidth,
                    height: pageHeight,
                    background: bgPreview ? `url(${bgPreview}) center/cover no-repeat` : "#FFFFFF",
                    border: "2px solid #FFFFFF",
                    maxWidth: "100%",
                  }}
                  onMouseMove={handleMouseMove}
                  onMouseUp={handleMouseUp}
                  onMouseLeave={handleMouseUp}
                  onDrop={(e) => {
                    e.preventDefault()
                    const fieldId = e.dataTransfer.getData("fieldId")
                    if (fieldId && !isLocked && backgroundCompleted) {
                      const rect = certificateRef.current.getBoundingClientRect()
                      const scale = rect.width / pageWidth
                      const x = (e.clientX - rect.left) / scale
                      const y = (e.clientY - rect.top) / scale
                      setInputFields((prev) =>
                        prev.map((field) => (field.id === fieldId ? { ...field, visible: true, x, y } : field)),
                      )
                      setSelectedFieldId(fieldId)
                    }
                  }}
                  onDragOver={(e) => e.preventDefault()}
                >
                  {!isLocked &&
                    imageFiles.map((img) => (
                      <div
                        key={img.id}
                        className="position-absolute rounded shadow-sm overflow-hidden"
                        style={{
                          left: img.x,
                          top: img.y,
                          width: img.width,
                          height: img.height,
                          cursor: "move",
                        }}
                        onMouseDown={(e) => handleImageMouseDown(e, img.id)}
                      >
                        <img
                          src={img.preview || "/placeholder.svg"}
                          alt=""
                          className="w-100 h-100"
                          style={{ objectFit: "cover", pointerEvents: "none" }}
                        />
                        <button
                          className="delete-btn position-absolute top-0 end-0 btn btn-danger btn-sm rounded-circle m-1"
                          style={{
                            width: 28,
                            height: 28,
                            fontSize: 12,
                            zIndex: 10,
                          }}
                          onClick={(e) => {
                            e.stopPropagation()
                            deleteImage(img.id)
                          }}
                        >
                          <MdDelete />
                        </button>
                        <div
                          className="resize-handle"
                          onMouseDown={(e) => handleImageResizeDown(e, img.id)}
                          style={{
                            position: "absolute",
                            right: -10,
                            bottom: -10,
                            width: 20,
                            height: 20,
                            background: "#0d6efd",
                            border: "3px solid white",
                            borderRadius: "50%",
                            cursor: "nwse-resize",
                            boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                            opacity: resizingImageId === img.id ? 1 : 0.7,
                          }}
                        />
                      </div>
                    ))}
                  {showPreviewElements &&
                    inputFields
                      .filter((f) => f.visible)
                      .map((field) => (
                        <div
                          key={field.id}
                          className="position-absolute"
                          style={{
                            left: field.x,
                            top: field.y,
                            width: field.width,
                            height: field.height,
                            cursor: isLocked ? "default" : "move",
                            border: selectedFieldId === field.id ? "2px dashed #3b82f6" : "none",
                            borderRadius: "4px",
                            overflow: "hidden",
                          }}
                          onMouseDown={(e) => handleTextMouseDown(e, field.id)}
                          onClick={() => {
                            setSelectedFieldId(field.id)
                          }}
                        >
                          <div
                            style={{
                              padding: "10px 14px",
                              fontSize: field.fontSize,
                              color: field.color,
                              fontFamily: field.fontFamily,
                              fontWeight: field.fontWeight,
                              whiteSpace: "nowrap",
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent:
                                field.textAlign === "center"
                                  ? "center"
                                  : field.textAlign === "right"
                                    ? "flex-end"
                                    : "flex-start",
                            }}
                          >
                            {field.fieldKey ? `{{${field.fieldKey}}}` : field.text}
                          </div>
                          {!isLocked && (
                            <div
                              className="resize-handle"
                              onMouseDown={(e) => handleTextResizeDown(e, field.id)}
                              style={{
                                position: "absolute",
                                right: -10,
                                bottom: -10,
                                width: 20,
                                height: 20,
                                background: "#0d6efd",
                                border: "3px solid white",
                                borderRadius: "50%",
                                cursor: "nwse-resize",
                                boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                                opacity: resizingTextId === field.id ? 1 : 0.7,
                              }}
                            />
                          )}
                        </div>
                      ))}
                  {showPreviewElements && qrVisible && (qrUrl || qrImage) && (
                    <div
                      className="position-absolute rounded shadow-lg overflow-hidden"
                      style={{
                        left: qrPosition.x,
                        top: qrPosition.y,
                        width: qrSize.width,
                        height: qrSize.height,
                        border: "4px solid white",
                        cursor: isLocked ? "default" : "move",
                      }}
                      onMouseDown={handleQRMouseDown}
                    >
                      <img src={qrUrl || qrImage} alt="QR" className="w-100 h-100" style={{ pointerEvents: "none" }} />
                      {!isLocked && (
                        <div
                          className="resize-handle"
                          onMouseDown={handleQRResizeDown}
                          style={{
                            position: "absolute",
                            right: -10,
                            bottom: -10,
                            width: 20,
                            height: 20,
                            background: "#0d6efd",
                            border: "3px solid white",
                            borderRadius: "50%",
                            cursor: "nwse-resize",
                            opacity: resizingQR ? 1 : 0.7,
                          }}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Alert Modal */}
        <Modal show={alertModal.show} onHide={() => setAlertModal({ ...alertModal, show: false })} centered>
          <Modal.Header
            style={{
              background:
                alertModal.variant === "success"
                  ? "#184778"
                  : alertModal.variant === "warning"
                    ? "#f59e0b"
                    : alertModal.variant === "danger"
                      ? "#ef4444"
                      : "#3b82f6",
              color: "#ffffff",
              borderRadius: "12px 12px 0 0",
              border: "none",
              padding: "16px 20px",
            }}
          >
            <Modal.Title style={{ fontSize: "16px", fontWeight: "600" }}>
              {alertModal.variant === "success" && "Success"}
              {alertModal.variant === "warning" && "Warning"}
              {alertModal.variant === "danger" && "Error"}
              {alertModal.variant === "info" && "Information"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "24px 20px", fontSize: "15px", color: "#374151" }}>
            {alertModal.message}
          </Modal.Body>
          <Modal.Footer style={{ border: "none", padding: "12px 20px 20px" }}>
            <Button
              style={{
                backgroundColor:
                  alertModal.variant === "success"
                    ? "#184778"
                    : alertModal.variant === "warning"
                      ? "#f59e0b"
                      : alertModal.variant === "danger"
                        ? "#ef4444"
                        : "#3b82f6",
                border: "none",
                borderRadius: "8px",
                padding: "10px 24px",
                fontWeight: "500",
              }}
              onClick={() => setAlertModal({ ...alertModal, show: false })}
            >
              OK
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Confirm Modal */}
        <Modal show={confirmModal.show} onHide={() => setConfirmModal({ ...confirmModal, show: false })} centered>
          <Modal.Header
            style={{
              background: "linear-gradient(135deg, #1e3a5f 0%, #2d4a6f 100%)",
              color: "#ffffff",
              borderRadius: "12px 12px 0 0",
              border: "none",
              padding: "16px 20px",
            }}
          >
            <Modal.Title style={{ fontSize: "16px", fontWeight: "600" }}>Confirm Action</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "24px 20px", fontSize: "15px", color: "#374151" }}>
            {confirmModal.message}
          </Modal.Body>
          <Modal.Footer style={{ border: "none", padding: "12px 20px 20px", gap: "12px" }}>
            <button
              style={{
                padding: "10px 24px",
                borderRadius: "8px",
                border: "2px solid #e5e7eb",
                backgroundColor: "#ffffff",
                color: "#6b7280",
                fontWeight: "500",
                cursor: "pointer",
              }}
              onClick={() => setConfirmModal({ ...confirmModal, show: false })}
            >
              Cancel
            </button>
            <button
              style={{
                padding: "10px 24px",
                borderRadius: "8px",
                border: "none",
                backgroundColor: "#1e3a5f",
                color: "#ffffff",
                fontWeight: "500",
                cursor: "pointer",
              }}
              onClick={() => {
                setConfirmModal({ ...confirmModal, show: false })
                if (confirmModal.onConfirm) confirmModal.onConfirm()
              }}
            >
              Confirm
            </button>
          </Modal.Footer>
        </Modal>
        {/* HTML Modal */}
        <Modal show={showHtmlModal} onHide={() => setShowHtmlModal(false)} size="xl">
          <Modal.Header
            style={{
              background: "linear-gradient(135deg, #1e3a5f 0%, #2d4a6f 100%)",
              color: "#ffffff",
              border: "none",
            }}
          >
            <Modal.Title>Generated HTML</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <textarea
              className="form-control"
              rows={20}
              value={generatedHtml}
              readOnly
              style={{ fontFamily: "monospace", fontSize: "12px" }}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowHtmlModal(false)}>
              Close
            </Button>
            <Button variant="primary" onClick={copyHtmlToClipboard}>
              Copy Code
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      {/* Spinner animation */}
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  )
}
export default Certificate
